export const MOBILE_BREAKPOINT = 980;

export const isMobile = () => {
    return window.innerWidth < MOBILE_BREAKPOINT;
};